import assert from "assert";
import phone from "phone";

const getPhoneNumber = (number: string): string => {
  const [ukNumber] = phone(number, "GBR");
  if (ukNumber) {
    return ukNumber;
  }

  // Apply some sensible corrections if the number doesn't look like it would be accepted by `phone`
  let fixed = number.replace(/^00/, "+");
  if (!fixed.startsWith("+")) {
    fixed = `+${fixed}`;
  }

  const [globalNumber] = phone(fixed, "");
  if (globalNumber) {
    return globalNumber;
  }
};

/** Validate that user input matches known prefixes for the given country (defaulting to UK if no country code) */
export const canNormalizePhone = (input: string) => !!getPhoneNumber(input);

/** Ensure a phone number matches E.164 format (+447000000000) */
export const normalizePhone = (input: string): string => {
  const normalizedNumber = getPhoneNumber(input);
  assert(normalizedNumber, "Can only normalize a valid phone number");
  return normalizedNumber;
};
